export default __webpack_public_path__ + "static/media/signature_4.84a117f9.png";